import type { LocalDate } from '@js-joda/core';
import type { EventType } from 'src/components/ui/EventList';

export type UserSetEventsUniverseAction = {
    type: 'userSetEventsUniverse';
    tabId: string;
    universeId: string | null;
};

export const userSetEventsUniverse = (tabId: string, universeId: string | null): UserSetEventsUniverseAction => ({
    type: 'userSetEventsUniverse',
    universeId: universeId,
    tabId,
});

export interface UserSetEventsSymbolFilter {
    type: 'userSetEventsSymbolFilter';
    symbol: string | null;
    tabId: string;
}

export const userSetEventsSymbolFilter = (tabId: string, symbol: string | null): UserSetEventsSymbolFilter => ({
    type: 'userSetEventsSymbolFilter',
    symbol,
    tabId,
});

export interface UserSetEventsEventTypes {
    type: 'userSetEventsEventTypes';
    eventTypes: EventType[];
    tabId: string;
}

export const userSetEventsEventTypes = (tabId: string, eventTypes: EventType[]): UserSetEventsEventTypes => ({
    type: 'userSetEventsEventTypes',
    eventTypes,
    tabId,
});

export interface UserSetEventsGoToDate {
    type: 'userSetEventsGoToDate';
    tabId: string;
    date: LocalDate | null;
}

export const userSetEventsGoToDate = (tabId: string, date: LocalDate | null): UserSetEventsGoToDate => ({
    type: 'userSetEventsGoToDate',
    date,
    tabId,
});

export type UpdateEventsSymbolFilterAction = { type: 'updateEventsSymbolFilter'; tabId: string; symbol: string };
export const updateEventsSymbolFilter = (tabId: string, symbol: string): UpdateEventsSymbolFilterAction => ({
    tabId,
    symbol,
    type: 'updateEventsSymbolFilter',
});

export interface UserSetEventsSymbolRetention {
    type: 'userSetEventsSymbolRetention';
    symbolRetention: string;
    tabId: string;
}

export const userSetEventsSymbolRetention = (tabId: string, symbolRetention: string): UserSetEventsSymbolRetention => ({
    type: 'userSetEventsSymbolRetention',
    symbolRetention,
    tabId,
});

export interface UserSetEventsSlowIdeaId {
    type: 'userSetEventsSlowIdeaId';
    tabId: string;
    slowIdeaId: string | null;
}

export const userSetEventsSlowIdeaId = (tabId: string, slowIdeaId: string | null): UserSetEventsSlowIdeaId => ({
    type: 'userSetEventsSlowIdeaId',
    slowIdeaId,
    tabId,
});

export interface UserSetEventsFastIdeaIds {
    type: 'userSetEventsFastIdeaIds';
    tabId: string;
    fastIdeaIds: string[];
}

export const userSetEventsFastIdeaIds = (tabId: string, fastIdeaIds: string[]): UserSetEventsFastIdeaIds => ({
    type: 'userSetEventsFastIdeaIds',
    fastIdeaIds,
    tabId,
});

export interface UserSetEventsDisplayingCalendar {
    type: 'userSetEventsDisplayingCalendar';
    tabId: string;
    displayingCalendar: boolean;
}

export const userSetEventsDisplayingCalendar = (
    tabId: string,
    displayingCalendar: boolean,
): UserSetEventsDisplayingCalendar => ({
    type: 'userSetEventsDisplayingCalendar',
    displayingCalendar,
    tabId,
});

export interface UserSetEventsSplitPercentage {
    type: 'userSetEventsSplitPercentage';
    tabId: string;
    splitPercentage: number;
}

export const userSetEventsSplitPercentage = (tabId: string, splitPercentage: number): UserSetEventsSplitPercentage => ({
    type: 'userSetEventsSplitPercentage',
    splitPercentage,
    tabId,
});

export type EventsWidgetActions =
    | UserSetEventsUniverseAction
    | UserSetEventsSymbolFilter
    | UserSetEventsEventTypes
    | UserSetEventsGoToDate
    | UpdateEventsSymbolFilterAction
    | UserSetEventsSymbolRetention
    | UserSetEventsSlowIdeaId
    | UserSetEventsFastIdeaIds
    | UserSetEventsDisplayingCalendar
    | UserSetEventsSplitPercentage;
